/* eslint-disable @typescript-eslint/no-unused-vars */
import { UserPreferences } from '@scenario/models/user-preferences.model';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';

export interface UserPreferencesState {
  userPreferences: UserPreferences;
  isFetching: boolean;
  error?: string;
}

const initialState: UserPreferencesState = {
  userPreferences: { unitId: 1, unitCurrency: 'EUR', unitTerm: 'REAL', unitRealYear: 2024, advanced: false, display: 'TABLE' },
  isFetching: false,
};

export const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    retrieveUserPreferences: state => {
      state.isFetching = true;
    },
    retrieveUserPreferencesSuccess: (state, action: PayloadAction<UserPreferences>) => {
      state.userPreferences = action.payload;
      state.isFetching = false;
    },
    retrieveUserPreferencesFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
    saveUserPreferences: (state, _action: PayloadAction<UserPreferences>) => {
      state.isFetching = true;
    },
    savedUserPreferencesSuccess: (state, action: PayloadAction<UserPreferences>) => {
      state.userPreferences = action.payload;
      state.isFetching = false;
    },
    savedUserPreferencesFailure: (state, action: PayloadAction<string>) => {
      state.isFetching = false;
      state.error = action.payload;
    },
  },
});

export type UserPreferencesViewModel = {
  userPreferences: UserPreferences;
  isFetching: boolean;
  error?: string;
};

const selectUserPreferences = (state: RootState) => state.userPreferences.userPreferences;
const selectIsFetching = (state: RootState) => state.userPreferences.isFetching;
const selectError = (state: RootState) => state.userPreferences.error;

export const selectUserPreferencesViewModel = createSelector(
  [selectUserPreferences, selectIsFetching, selectError],
  (userPreferences, isFetching, error): UserPreferencesViewModel => ({
    userPreferences,
    isFetching,
    error,
  }),
);

export const {
  retrieveUserPreferences,
  retrieveUserPreferencesSuccess,
  retrieveUserPreferencesFailure,
  saveUserPreferences,
  savedUserPreferencesSuccess,
  savedUserPreferencesFailure,
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
